// @flow

import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import {
    toggleCustomNoiseSuppression
} from '../../components/customStorageSettings/actions';

/**
 * Listens for changes in the full screen state to send analytics.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/noise-suppression'],
    /* listener */ ({ enabled }, { dispatch }, prevState) => {
        if (typeof prevState === 'undefined') {
            dispatch(toggleCustomNoiseSuppression(enabled));
        }
    }
);
